{
  "header": "Detalles de Liquidación",
  "disbursement-flow": "Flujo de Desembolsos",
  "receipt-flow": "Flujo de Recibos",
  "total-amount": "Cantidad Total",
  "entries-count": "Total de Entradas",
  "accounted-entries": "Entradas Contabilizadas",
  "accounted-entries-short": "contabilizadas",
  "accounted-count": "contabilizadas: {{count}}",
  "accounted-sum": "Suma Contabilizada",
  "accounted-percent": "Porcentaje Contabilizado",
  "accounted-percent-label": "del total",
  "no-data": "No hay datos de liquidación disponibles",
  "entry": "Entrada",
  "description": "Descripción",
  "amount": "Cantidad",
  "party": "Parte",
  "kind": "Tipo",
  "amount-party": "Cantidad (Parte)",
  "percent": "Porcentaje",
  "accounted": "Contabilizado",
  "rest": "Resta",
  "payers": "Pagadores",
  "payees": "Beneficiarios",
  "no-payers": "Sin pagadores",
  "no-payees": "Sin beneficiarios",
  "difference": "Diferencia",
  "balanced": "Balanceados",
  "total": "Total",
  "imbalance-warning": "Los pagadores y beneficiarios no están balanceados",
  "incomplete-data-warning": "Se necesita al menos un pagador contabilizado o un beneficiario contabilizado para comparar",
  "issues": "Problemas",
  "no-issues": "Sin problemas",
  "all": "Todos",
  "override-flag": "Sobrescritura",
  "pending-references": "Referencias Pendientes",
  "entry-date": "Fecha de Entrada",
  "party-role": "Rol de la Parte",
  "entity": "Entidad"
}
